<nf-grid-wrapper
  [gridApi]="gridApi?.api"
  [hideClearAll]="true"
  [hideSearch]="true"
  role="group"
  attr.aria-label="Distributions"
>
  <nf-grid-wrapper-header-left>
    <h2 class="title">Distributions</h2>
  </nf-grid-wrapper-header-left>
  <!-- <ng-grid-wrapper-header-right>
    <button
      nf-icon-button="secondary"
      ngbTooltip="Filters Modal"
      placement="bottom-right"
      icon="filter"
      (click)="launchFiltersModal()"
      style="margin-left: 8px"
      data-cy="advancedFiltersBtn"
    >
      Open Filters Modal
    </button>
    <hs-applied-filter-counts
      [filterCount]="filterCount"
    ></hs-applied-filter-counts>
  </ng-grid-wrapper-header-right> -->
  <ng-grid-wrapper-header-right>
    <nf-checkbox
      class="small mr-2"
      [formControl]="hideFutureGroupEntryDatesToggle"
      label="Hide Future Entry Dates"
    ></nf-checkbox>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      id="clear-all-filters-button"
      nf-icon-button="secondary"
      ngbTooltip="Clear Filters"
      icon="filter-remove"
      (click)="clearFilters()"
      class="filter-button"
      [disabled]="!clearFiltersEnabled"
      placement="bottom-right"
    >
      Clear All Filters
    </button>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content>
    <nf-table-layout
      #table
      class="distributions-table-layout"
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      [data]="data"
      [autoResizeGrid]="false"
      hideSearch
      hideClearAll
      hideTitle
    >
      <ng-content></ng-content>
    </nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
